import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {User} from '../models/user';

@Injectable()
export class UsersService {

    constructor(private http: HttpClient) {
    }

    getUsers(): Observable<User[]> {
        return this.http.get<User[]>(`${environment.apiBaseUrl}users`);
    }

    getUser(userId: string): Observable<User> {
        return this.http.get<User>(`${environment.apiBaseUrl}users/${userId}`);
    }

    createUser(user: any): Observable<any> {
        return this.http.post(`${environment.apiBaseUrl}users`, user);
    }

    updateUser(user: any, userId: string): Observable<any> {
        return this.http.put(`${environment.apiBaseUrl}users/${userId}`, user);
    }

    deleteUser(userId: string): Observable<any> {
        return this.http.delete(`${environment.apiBaseUrl}users/${userId}`);
    }
}
